import type { ProductMessage } from '../../../../types/ProductMessage';
import type { PaginatedAsyncComboBoxProps } from '../../../cdl/ComboBox/ComboBox';

import type { ProductOption } from './ProductOption';
import { ProductSelectControl } from './ProductSelectControl';
import { useProductSelectOptions } from './useProductSelectOptions';

export type { ProductOption } from './ProductOption';

export interface ProductSelectProps
    extends Omit<
        PaginatedAsyncComboBoxProps<ProductOption>,
        'onChange' | 'value' | 'optionsQueryKey' | 'optionsQueryFn' | 'selectedOptionQueryKey' | 'selectedOptionQueryFn'
    > {
    onChange: (option: ProductOption | null) => void;
    value: string;
    defaultProducts?: ProductMessage[];
    excludedProductIds?: string[];
    hideSuccessorProduct?: boolean;
    vesselId?: string;
}

export const ProductSelect = ({
    defaultProducts,
    excludedProductIds,
    hideSuccessorProduct = false,
    onChange,
    value,
    vesselId,
    ...rest
}: ProductSelectProps) => {
    const { cacheSelectedValue, loadProductById, loadProducts, selectedValue } = useProductSelectOptions({
        defaultProducts,
        excludedProductIds,
        value,
        vesselId,
    });

    function updateSelectedValue(option: ProductOption | null) {
        if (option) {
            cacheSelectedValue(option);
        }

        onChange(option);
    }

    return (
        <ProductSelectControl
            {...rest}
            hideSuccessorProduct={hideSuccessorProduct}
            selectedValue={selectedValue}
            onSelectedValueChange={updateSelectedValue}
            loadOptions={loadProducts}
            loadSelectedOption={loadProductById}
            value={value}
            optionsQueryParams={{
                defaultProductIds: defaultProducts?.map((product) => product.id),
                excludedProductIds,
                vesselId,
            }}
        />
    );
};
